import dayjs from '../../dayjs';
import { DateType } from '../types'
import { isNil } from '../common'

/**
 * @description: 根据传入日期和周起始日，获取该日期所在的周属于当年的第几周
 * @param {*} date
 * @param {*} weekStart
 * @return {*}
 */
export const getWeekOfYear = (date: DateType, weekStart?: number) => {
  if (weekStart === 0 || isNil(weekStart)) {
    return dayjs(date).week()
  } else {
    weekStart = weekStart % 7
    const yearStart = dayjs(date).set('month', 0).set('date', 1)
    const firstDay = dayjs(yearStart).day()
    const numberDay = dayjs(date).dayOfYear()
    //根据第一天的星期和设定的开始日期，计算实际的起始日期
    const diff = firstDay >= weekStart ? firstDay - weekStart : 7 - (weekStart - firstDay)
    const week = Math.floor((numberDay + diff - 1) / 7) + 1
    return week
  }
}

/**
 * @description: 根据传入的起止周，获取传入天数每周的开始天和结束天
 * @param {*} date
 * @param {*} weekStart
 * @return {*}
 */
export function getWeekBoundary(date = dayjs(), weekStart = 0) {
  let [st, et] = [dayjs(), dayjs()]
  const difference = (dayjs(date).day() - weekStart)
  if (difference >= 0) {
    st = dayjs(date).subtract(difference, 'day')
  } else {
    st = dayjs(date).subtract((7 + difference), 'day')
  }
  et = dayjs(st).add(6, 'day')
  return {
    thisWeekStartDay: st,
    thisWeekEndDay: et
  }
}